import ApiClient from "@common/api/ApiClient";

/**
 * Class representing a client for officers.
 * Extends the ApiClient to provide specific functionalities for API requests.
 *
 * @extends ApiClient
 */
class OfficerClient extends ApiClient {
  /**
   * Create a OfficerClient.
   * Initializes the API client with the "Officer" route and sets the API URL key.
   */
  constructor() {
    super("Officer");
    this.setApiUrlKey("comp_api_url");
  }

  MetaData = async () => await this.get("Create");

  Create = async (payload) => await this.post("Create", payload);

  Search = async (payload = { badgeNumber: "", officerTypeId: "" }) =>
    await this.post("Search", payload);
}

const client = new OfficerClient();

export default client;
